import React, { useState, useEffect, useReducer, useContext, useCallback } from "react";
import { toast } from "react-toastify";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import QuickMessageDialog from "../../components/QuickMessageDialog";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { Grid, Box, Chip, Divider } from "@material-ui/core";
import { isArray } from "lodash";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import AddIcon from '@mui/icons-material/Add';


const reducer = (state, action) => {
  if (action.type === "LOAD_QUICKMESSAGES") {
    //console.log("aqui");
    //console.log(action);
    //console.log(action.payload);
    const quickmessages = action.payload;
    const newQuickmessages = [];
    //console.log(newQuickmessages);

    if (isArray(quickmessages)) {
      quickmessages.forEach((quickemessage) => {
        const quickemessageIndex = state.findIndex(
          (u) => u.id === quickemessage.id
        );
        if (quickemessageIndex !== -1) {
          state[quickemessageIndex] = quickemessage;
        } else {
          newQuickmessages.push(quickemessage);
        }
      });
    }

    return [...state, ...newQuickmessages];
  }

  if (action.type === "UPDATE_QUICKMESSAGES") {
    const quickemessage = action.payload;
    const quickemessageIndex = state.findIndex((u) => u.id === quickemessage.id);

    if (quickemessageIndex !== -1) {
      state[quickemessageIndex] = quickemessage;
      return [...state];
    } else {
      return [quickemessage, ...state];
    }
  }

  if (action.type === "DELETE_QUICKMESSAGE") {
    const quickemessageId = action.payload;

    const quickemessageIndex = state.findIndex((u) => u.id === quickemessageId);
    if (quickemessageIndex !== -1) {
      state.splice(quickemessageIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "scroll",
    backgroundColor: theme.palette.background.default,
    border: "none",
    ...theme.scrollbarStyles,
  },

  headerContainer: {
    background: "linear-gradient(90deg, #6517ab 0%, #8e44ad 100%)",
    padding: theme.spacing(3),
    borderRadius: "0 0 20px 20px",
    color: "white",
    marginBottom: theme.spacing(3),
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  },
  title: {
    color: "white",
    fontWeight: "bold",
  },
  searchPaper: {
    padding: "4px 16px",
    display: "flex",
    alignItems: "center",
    borderRadius: "15px",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    "& .MuiInputBase-root": {
      color: "white",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "rgba(255, 255, 255, 0.7)",
      opacity: 1,
    },
  },
  addButton: {
    background: theme.palette.background.paper,
    color: "#6517ab",
    borderRadius: "15px",
    padding: "10px 20px",
    fontWeight: "600",
    textTransform: "none",
    "&:hover": {
      background: theme.palette.type === "light" ? "#f0f0f0" : "rgba(255, 255, 255, 0.1)",
    },
  },

  tabsContainer: {
    marginBottom: theme.spacing(2),
    "& .MuiTabs-indicator": {
      backgroundColor: "#6517ab",
    },
    "& .MuiTab-root": {
      fontWeight: 600,
      textTransform: "none",
      color: theme.palette.text.secondary,
      "&.Mui-selected": {
        color: "#6517ab",
      },
    },

  },
  quickMessageCard: {
    borderRadius: "20px",
    transition: "all 0.3s ease",
    border: "none",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
    background: theme.palette.background.paper,
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    },
  },

  cardContent: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },
  shortcodeChip: {
    borderRadius: "10px",
    fontWeight: "600",
    backgroundColor: theme.palette.type === "light" ? "#f3e5f5" : "rgba(101, 23, 171, 0.2)",
    color: "#6517ab",
  },

  iconButton: {
    borderRadius: "12px",
    margin: theme.spacing(0, 0.5),
    transition: "all 0.2s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
}));

const Quickemessages = () => {
  const classes = useStyles();
  const theme = useTheme();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedQuickemessage, setSelectedQuickemessage] = useState(null);
  const [deletingQuickemessage, setDeletingQuickemessage] = useState(null);
  const [quickemessageModalOpen, setQuickMessageDialogOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [tabValue, setTabValue] = useState("table");
  const [quickemessages, dispatch] = useReducer(reducer, []);
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const { profile } = user;

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchQuickemessages();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    const companyId = user.companyId;
    // const socket = socketManager.GetSocket();

    const onQuickMessageEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_QUICKMESSAGES", payload: data.record });
      }
      if (data.action === "delete") {
        dispatch({ type: "DELETE_QUICKMESSAGE", payload: +data.id });
      }
    };
    socket.on(`company-${companyId}-quickemessage`, onQuickMessageEvent);

    return () => {
      socket.off(`company-${companyId}-quickemessage`, onQuickMessageEvent);
    };
  }, [socket]);

  const fetchQuickemessages = async () => {
    try {
      const companyId = user.companyId;
      //const searchParam = ({ companyId, userId: user.id });
      const { data } = await api.get("/quick-messages", {
        params: { searchParam, pageNumber },
      });

      dispatch({ type: "LOAD_QUICKMESSAGES", payload: data.records });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenQuickMessageDialog = () => {
    setSelectedQuickemessage(null);
    setQuickMessageDialogOpen(true);
  };

  const handleCloseQuickMessageDialog = () => {
    setSelectedQuickemessage(null);
    setQuickMessageDialogOpen(false);
    //window.location.reload();
    fetchQuickemessages();
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleEditQuickemessage = (quickemessage) => {
    //console.log(quickemessage);
    setSelectedQuickemessage(quickemessage);
    setQuickMessageDialogOpen(true);
  };

  const handleDeleteQuickemessage = async (quickemessageId) => {
    try {
      await api.delete(`/quick-messages/${quickemessageId}`);
      toast.success(i18n.t("Resposta Rápida Deletada com Sucesso"));
    } catch (err) {
      toastError(err);
    }
    setDeletingQuickemessage(null);
    setSearchParam("");
    setPageNumber(1);
    fetchQuickemessages();
    dispatch({ type: "RESET" });

  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={deletingQuickemessage && `${i18n.t("quickMessages.confirmationModal.deleteTitle")} ${deletingQuickemessage.shortcode}?`}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteQuickemessage(deletingQuickemessage.id)}
      >
        {i18n.t("quickMessages.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <QuickMessageDialog
        resetPagination={() => {
          setPageNumber(1);
          fetchQuickemessages();
        }}
        open={quickemessageModalOpen}
        onClose={handleCloseQuickMessageDialog}
        aria-labelledby="form-dialog-title"
        quickemessageId={selectedQuickemessage && selectedQuickemessage.id}
      />
      <div className={classes.headerContainer}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h5" className={classes.title}>
              {i18n.t("quickMessages.title")}
            </Typography>
            <Typography variant="body1" style={{ opacity: 0.8 }}>
              Crie atalhos para suas mensagens mais utilizadas.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item xs={12} sm={7}>
                <Paper className={classes.searchPaper} elevation={0}>
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "rgba(255,255,255,0.7)" }} />
                  </InputAdornment>
                  <TextField
                    fullWidth
                    placeholder={i18n.t("quickMessages.searchPlaceholder")}
                    type="search"
                    value={searchParam}
                    onChange={handleSearch}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Paper>
              </Grid>
              <Grid item xs={12} sm={5}>
                <Button
                  fullWidth
                  variant="contained"
                  className={classes.addButton}
                  startIcon={<AddIcon />}
                  onClick={handleOpenQuickMessageDialog}
                >
                  {i18n.t("quickMessages.buttons.add")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="abas"
        className={classes.tabsContainer}
      >
        <Tab label="Tabela" value="table" />
        <Tab label="Grade" value="grid" />
      </Tabs>
      <Paper
        className={classes.mainPaper}
        variant="outlined"
        onScroll={handleScroll}
      >
        {tabValue === "table" && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center">Atalho</TableCell>
                <TableCell align="left">Mensagem</TableCell>
                <TableCell align="center">Anexo</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {quickemessages.map((quickemessage) => (
                <TableRow key={quickemessage.id}>
                  <TableCell align="center">{quickemessage.shortcode}</TableCell>
                  <TableCell align="left">{quickemessage.message}</TableCell>
                  <TableCell align="center">
                    {quickemessage.mediaName ?? i18n.t("quickMessages.noAttachment")}
                  </TableCell>
                  <TableCell align="center">
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <IconButton
                        size="small"
                        onClick={() => handleEditQuickemessage(quickemessage)}
                        style={{
                          backgroundColor: theme.palette.type === 'dark' ? "rgba(101, 23, 171, 0.15)" : "rgba(101, 23, 171, 0.1)",
                          padding: "8px",
                          borderRadius: "10px",
                          color: "#6517ab"
                        }}
                        title="Editar"
                      >
                        <EditIcon />
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={() => {
                          setConfirmModalOpen(true);
                          setDeletingQuickemessage(quickemessage);
                        }}
                        style={{
                          backgroundColor: theme.palette.type === 'dark' ? "rgba(255, 107, 107, 0.15)" : "#ffebee",
                          padding: "8px",
                          borderRadius: "10px",
                          color: "#FF6B6B"
                        }}
                        title="Excluir"
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
              {loading && <TableRowSkeleton columns={4} />}
            </TableBody>
          </Table>
        )}
        {tabValue === "grid" && (
          <Grid container spacing={2}>
            {quickemessages.map((quickemessage) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={quickemessage.id}>
                <Card className={classes.quickMessageCard} elevation={0}>
                  <CardContent className={classes.cardContent}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                      <Chip
                        label={`#${quickemessage.shortcode}`}
                        className={classes.shortcodeChip}
                        size="small"
                      />
                      {quickemessage.mediaName && (
                        <Chip
                          label="Anexo"
                          variant="outlined"
                          size="small"
                          style={{ color: "#6517ab", borderColor: "#6517ab" }}
                        />
                      )}
                    </Box>

                    <Typography variant="body1" color="textPrimary" style={{ fontWeight: 500, marginBottom: "16px", minHeight: "60px", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical" }}>
                      {quickemessage.message}
                    </Typography>

                    <Divider style={{ margin: "16px 0" }} />

                    <Box display="flex" justifyContent="center">
                      <IconButton
                        size="small"
                        onClick={() => handleEditQuickemessage(quickemessage)}
                        className={classes.iconButton}
                        style={{ backgroundColor: "#f3e5f5", color: "#6517ab" }}
                        title="Editar"
                      >
                        <EditIcon />
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={() => {
                          setConfirmModalOpen(true);
                          setDeletingQuickemessage(quickemessage);
                        }}
                        className={classes.iconButton}
                        style={{ backgroundColor: "#ffebee", color: "#d32f2f" }}
                        title="Excluir"
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            {loading && (
              <Grid item xs={12}>
                <Typography align="center">Loading...</Typography>
              </Grid>
            )}
          </Grid>
        )}
      </Paper>
    </MainContainer>
  );
};

export default Quickemessages;